module.exports = __webpack_public_path__ + "img/starfighter-twin-ion-engine.4e1dc0a1.svg";